import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <HashRouter>
      <Provider store={store}>
        <App store={store} dispatch={store.dispatch.bind(store)} />
      </Provider>
    </HashRouter>
);


reportWebVitals();
